//Token for telco user flow (Partners)
import { httpService } from 'src/services/fetch/HttpService';
import { TELCO_TOKEN_URL } from 'src/utils/constants/ApiConstants';
import {
  HTTP_HEADER_KEYS,
  HTTP_HEADER_VALUES,
  HTTP_METHODS
} from 'src/utils/constants/HttpMethodsConstants';

import { getAPIHeaders } from '../LoginService';

/**
 * This function is responsible to fetch long token using short token.
 * It is called in partners like vimTV, vimtv_android tatasky, samsungGalaxy and activate tv flows
 * Check PartnerPlatforms Enum for more info.
 *
 * @param tag : This is short token sent in URL
 * @param pathName : This is fallback path. Where user should go after fetching long token.
 */
export const fetchTelcoUserToken = async (tag: string) => {
  const headers = getAPIHeaders();
  // Custom header used because for CONTENT_TYPE default value is application/json
  // but we have to use application/x-www-form-urlencoded
  const customHeader = [
    {
      key: HTTP_HEADER_KEYS.CONTENT_TYPE,
      value: HTTP_HEADER_VALUES.APPLICATION_FORM_URL_ENCODED
    }
  ];

  const reqBodyObj = new URLSearchParams(
    `${encodeURIComponent('token')}=${encodeURIComponent(tag)}`
  );

  const response = await httpService.fetchApiData({
    url: TELCO_TOKEN_URL,
    type: HTTP_METHODS.POST,
    body: reqBodyObj,
    headers,
    customHeader
  });

  return response;
};
